import React from 'react';
import { motion } from 'framer-motion';
import { cn } from './utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'default' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  fullWidth = false,
  className,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('relative overflow-hidden rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:ring-offset-2 focus:ring-offset-zinc-950', variant === 'primary' && 'bg-zinc-100 text-zinc-900 hover:bg-white shadow-[0_0_20px_rgba(255,255,255,0.1)]', variant === 'outline' && 'border border-zinc-700 bg-transparent text-zinc-300 hover:bg-zinc-800 hover:text-white', size === 'default' && 'px-6 py-3 text-sm', size === 'lg' && 'px-8 py-4 text-base md:text-lg', fullWidth && 'w-full', className)} {...props} data-id="element-173">
      {variant === 'primary' && <div className="absolute inset-0 bg-chakra-gradient opacity-10 mix-blend-multiply" data-id="element-174" />}
      <span className="relative z-10" data-id="element-175">{children}</span>
    </motion.button>;
}